import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children, showInvestor = false }) {
  return (
    <div className="App min-h-screen bg-navy">
      <Navbar />
      <main>{children}</main>
      <Footer showInvestor={showInvestor} />
    </div>
  );
}
